<template>
  <AModal
    v-model="valueComputed"
    size="lg"
    class="person-modal"
    disable-portaling
  >
    <div
      class="person-modal-header"
      :class="modalHasBackgroundImage"
    >
      <!-- <template v-if="person.backgroundImage">
      <div class="person-modal-header-background" :style="{ backgroundImage: 'url(' + person.backgroundImage + ')' }"></div>
    </template> -->
      <div class="person-modal-header-content" />
    </div>
    <div class="profile-image-container">
      <AImage
        :img="image"
        :placeholder-url="require('assets/image-placeholders/person-placeholder.svg')"
        ratio="1-1"
        preset="peoplegroupperson"
        cover
      />
    </div>
    <div class="speaker-modal-content">
      <div class="person-info">
        <h2>{{ name }} </h2>
        <div class="position">
          {{ position }}
          <span v-if="position && organisation">,</span>
          {{ organisation }}
        </div>
      </div>
      <div
        class="person-description"
        v-html="description"
      />
      <div class="person-contact">
        <ul class="person-contact-list">
          <li
            v-if="contactPhone"
            class="person-contact-list-item"
          >
            <a :href="`tel:${contactPhone}`">   <span class="contact-icon"><font-awesome-icon icon="mobile" /></span> <span>{{ contactPhone }} </span></a>
          </li>
          <li
            v-if="contactUrl"
            class="person-contact-list-item"
          >
            <a
              :href="$options.filters.toUrl(contactUrl)"
              target="_blank"
            >  <span class="contact-icon"> <font-awesome-icon icon="comment" /> </span> <span>Contact {{ name }} </span></a>
          </li>
        </ul>
      </div>
      <!-- <template v-if="person.personSocial && person.personSocial.length > 1">
          <div class="author-social">
            <ul class="author-social-list">
              <li v-for="(personSocialItem, index) in person.personSocial" :key="index" class="author-social-list-item">
                <a :href="personSocialItem.socialURL" target="_blank" rel="noopener" :title="personSocialItem.socialTitle">
                  <span class="social-icon" :class="[personSocialItem.socialIcon]">
                    <font-awesome-icon :icon="getIcon(personSocialItem.socialIcon)" class="icon" />
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </template> -->
    </div>
  </AModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faLink,
  faMobile,
  faShare,
  faComment
} from '@fortawesome/free-solid-svg-icons'
import {
  faTwitter,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faGooglePlus
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faTimes,
  faLink,
  faMobile,
  faComment,
  faTwitter,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faShare,
  faGooglePlus
)

export default {
  name: 'sp-people-group-modal',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  computed: {
    valueComputed: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      return this.person.name
    },
    description() {
      return this.person.description
    },
    image() {
      return this.person.image
    },
    hasImage() {
      return this.person.image && this.person.image.filestorename && this.person.image.filepath
    },
    position() {
      return this.person.job
    },
    organisation() {
      return this.person.organisation
    },
    contactUrl() {
      return this.person.contactUrl
    },
    contactPhone() {
      return this.person.contactPhone
    },
    modalHasBackgroundImage() {
      if (this.person.backgroundImage) {
        return 'has-image'
      }
      else { return 'has-no-image' }
    }
  },
  methods: {
    getIcon: function(type) {
      switch (type) {
      // social media icons
      case 'twitter':
        return ['fab', 'twitter']
      case 'facebook':
        return ['fab', 'facebook-f']
      case 'instagram':
        return ['fab', 'instagram']
      case 'linkedin':
        return ['fab', 'linkedin-in']
      case 'youtube':
        return ['fab', 'youtube']
      case 'share':
        return ['fab', 'share']
      case 'website':
        return 'link'
      case 'googleplus':
        return ['fab', 'google-plus']
      default:
        return ['fab', 'share']
      }
    }
  }
}
</script>
<style lang="scss">
  @import '~@scss/custom.scss';

  //person modal display
  .person-modal {
    .modal-inner {
      position: relative;
      .modal-header {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 1002;
      }
      .modal-body {
        padding: 0 !important;
      }
    }
  }
  .person-modal {
    color: var(--main-text-color);
    .person-info {
      border-bottom: 1px solid;
      border-color: var(--main-border-color);
      text-align: center;
      padding-bottom: 1.5em;
      margin-bottom: 1.5em;
      .position {
        font-style: italic;
      }
    }
    .modal-content {
      overflow: hidden;
    }
    .person-description {
      margin-bottom: 1.5em;
    }
    .profile-image-container {
      height: 12em;
      width: 12em;
      margin-top: -6em;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      border-radius: 100%;
      overflow: hidden;
      z-index: 3;
      backface-visibility: hidden;
      transform: translate3d(0, 0, 0);
      background: var(--main-image-background-color);

      .low-res {
        clip-path: circle(50% at 50% 50%);
      }
    }
    .speaker-modal-content {
      padding: 1.5rem;
      @include media-breakpoint-up(md) {
        padding: 1.5rem 5rem;
      }
    }
    .modal-body {
      padding: 0rem;
    }
    .person-modal-header-background {
      background-position: 50% 50%;
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      &:before {
        background: rgba(0, 0, 0, 0.15);
        height: 100%;
        width: 100%;
        z-index: 0;
        position: absolute;
        content: " ";
        left: 0;
        overflow: hidden;
        top: 0;
      }
    }
    .person-modal-header {
      display: flex;
      align-items: center;
      padding: 3em 3em;
      min-height: 12em;
      position: relative;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.15);
    }
    .has-image {
      .close-modal {
        color: var(--main-text-overly-color);
      }
    }
    .close-modal {
      background: none;
      border: none;
      font-size: 2rem;
      color: var(--main-text-color);
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
      cursor: pointer;
      @include transition (opacity .3s);
      @include hover-focus {}
    }
  }

</style>
<style lang="scss" scoped>

  @mixin responsive-ratio($x,$y, $pseudo: false) {
    $padding: unquote( ( $y / $x ) * 100 + '%' );
    @if $pseudo {
        &:before {
            @include pseudo($pos: relative);
            width: 100%;
            padding-bottom: $padding;
        }
    } @else {
        padding-bottom: $padding;
    }
  }

  ::v-deep .profile-image-container {
    .image-background {
      background-color: var(--main-image-background-color);
      transform: perspective(1px) scale(1);
      transform-origin: center;
      &.ratio-16-10 {
        @include responsive-ratio(16, 10);
      }
      &.ratio-16-9 {
        @include responsive-ratio(16, 9);
      }
      &.ratio-3-2 {
        @include responsive-ratio(3, 2);
      }
      &.ratio-4-3 {
        @include responsive-ratio(4, 3);
      }
      &.ratio-3-4 {
          @include responsive-ratio(3, 4);
      }
      &.ratio-square,
      &.ratio-1-1,
      &.ratio-1-1-round{
        @include responsive-ratio(1, 1);
      }
    }
  }

 ::v-deep .modal-content {
    background-color: var(--main-background-color);
    color: var(--main-text-color);
    border: 0px;
  }

  //person social display
  .author-social {
    border-top: 1px solid;
    border-color: var(--main-border-color);
    padding-top: 1.5em;
    margin-top: 1.5em;
    .author-social-list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      flex-direction: row;
      list-style: none;
      padding: 0em;
      margin: 0em;
      .author-social-list-item {
        margin: .5em;
      }
    }
    .social-icon {
      box-sizing: content-box;
      height: 1em;
      width: 1em;
      padding: .75em;
      justify-content: center;
      align-items: center;
      display: flex;
      border-radius: 100%;
      color: var(--main-text-overly-color);
      &.facebook {
        background-color: var(--social-facebook);
      }
      &.twitter {
        background-color: var(--social-twitter);
      }
      &.instagram {
        background-color: var(--social-instagram);
      }
      &.linkedin {
        background-color: var(--social-linkedin);
      }
      &.instagram {
        background-color: var(--social-instagram);
      }
      &.website {
        background-color: var(--social-website);
      }
      &.youtube {
        background-color: var(--social-youtube);
      }
    }
  }

  .person-contact-list {
    list-style: none;
    padding: 0em;
    display: flex;
    justify-content: center;
  }

  .person-contact-list-item {
    margin: 0em 1em;
  }

  .person-contact-list-item a {
    display: flex;
    align-items: center;
    color: var(--main-text-color);
  }

  .contact-icon {
    box-sizing: content-box;
    height: 1em;
    width: 1em;
    padding: .75em;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 100%;
    border: 1px solid;
    border-color: var(--main-border-color);
    margin-right: 1em;
  }

  .placeholder-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    z-index: 2;
   ::v-deep svg {
      path {
        fill: var(--main-background-color);
      }
    }
  }
</style>
